<template>
  <div class="form-row inline-label">
    <p style="color: red;">Let op! Wil je je abonnement in termijnen betalen? Kies dan in het betaalscherm voor het betalen in 9 termijnen. De eerste maand betaal je nu gelijk via iDeal en daarna worden de 9 overgebleven termijnen maandelijkse geïncasseerd.</p>
    <div class="form-column">
      <label>{{ $t('paymentSelection.termOverview.title') }}</label>
      <table class="term-overview">
        <thead>
          <tr>
            <th>{{ $t('paymentSelection.termOverview.tableColumn.product') }}</th>
            <th>{{ $t('paymentSelection.termOverview.tableColumn.payDirect') }}</th>
            <th>{{ $t('paymentSelection.termOverview.tableColumn.payRemaining') }}</th>
            <th>{{ $t('paymentSelection.termOverview.tableColumn.nrOfTerms') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(productItem, key) in cartProductItems" :key="key">
            <td>{{ productItem.productTitle }}</td>
            <td class="downPaymentAmount">{{ $n(getDirectAmount(productItem), 'currency') }}</td>
            <td class="remainingAmount">{{ $n(getTermAmount(productItem), 'currency') }}</td>
            <td>
              <select
                v-if="getTermsForCartProductItem(productItem).length > 0"
                :name="'instalments[' + productItem.orderItemId + ']'"
                :id="'instalments-' + productItem.orderItemId"
                class="small instalmentSelect"
                @change="event => selectTerm(event.target.value, productItem)">
                <option
                  v-for="term in getTermsForCartProductItem(productItem)"
                  :value="term.value"
                  :key="term.value"
                  :selected="productItem.nrOfTerms === term.value"
                >{{ term.label }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermOverview',
  props: {
    paymentConfigurations: {
      type: Object,
      default: () => {}
    },
    cartProductItems: {
      type: Array,
      default: () => []
    }
  },
  mounted: function () {
    this.cartProductItems.forEach(productItem => {
      const configurations = this.getTermsForCartProductItem(productItem)
      if (configurations.length && !configurations.find(nrOfTerms => nrOfTerms === productItem.nrOfTerms)) {
        this.selectTerm(configurations[0].value, productItem)
      }
    })
  },
  methods: {
    getTermsForCartProductItem (productItem) {
      if (this.paymentConfigurations[productItem.orderItemId] &&
        this.paymentConfigurations[productItem.orderItemId].paymentTermConfigurations &&
        this.paymentConfigurations[productItem.orderItemId].paymentTermConfigurations.length > 0
      ) {
        return this.paymentConfigurations[productItem.orderItemId].paymentTermConfigurations.map(
          paymentTermConfiguration => {
            const leftTerms = paymentTermConfiguration.nrOfTerms - 1

            return {
              value: paymentTermConfiguration.nrOfTerms,
              label: leftTerms > 0 ? leftTerms : this.$t('paymentSelection.termOverview.singleTermOptionLabel')
            }
          }
        )
      }

      return []
    },

    async selectTerm (value, productItem) {
      const nrOfTerms = parseInt(value)
      await this.$store.dispatch('cart/setTermsForCartProductItem', { terms: nrOfTerms, cartProductItem: productItem })
      await this.$store.dispatch('cart/updatePaymentSpecification')
    },

    getDirectAmount (productItem) {
      return productItem.directPayment ? productItem.directPayment.totalPriceLine.amountWithVat.amount : 0
    },

    getTermAmount (productItem) {
      return productItem.termPayments ? productItem.termPayments.reduce(
        (totalTermAmount, termPayment) => totalTermAmount + termPayment.totalPriceLine.amountWithVat.amount,
        0
      ) : 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment-selection/TermOverview.vue